import { Navigate } from "react-router-dom";

import { ReactNode } from "react";

export const PublicRoute: React.FC<{ children: ReactNode | any }> = ({
  children,
}) => {
  const isLogged = localStorage.getItem("accessToken");
  return !isLogged ? children : <Navigate to="/dashboard" />;
};
